(function AdzukiConfirm($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['confirm', 'cancel'],
		props: {
			show : Boolean,
			title: {
				type   : String,
				default: 'Confirm Action'
			},
			message: {
				type   : String,
				default: 'Are you sure you want to proceed?'
			},
			style: {
				type   : String,
				default: 'old'
			}
		},
		template: `
			<div class="confirm-overlay">
				<template v-if="style === 'old'">
					<div class="confirm-dialog bg-confirm-blue rounded rounded-1 p-1" :class="style">
						<div class="fw-bold p-3 fs-4">
							<span v-html="title"></span>
						</div>
						<div class="mb-3">
							<div class="px-3" v-html="message"></div>
						</div>
						<div class="p-2 text-end">
							<button type="button" class="btn btn-confirm-darkblue me-1 rounded roun" @click="confirm">Yes</button>
							<button type="button" class="btn btn-muted-button" @click="cancel">No</button>
						</div>
					</div>
				</template>
				<template v-if="style === 'new'">
					<div class="confirm-dialog bg-black rounded rounded-4 text-white p-4" :class="style">
						<h3 v-html="title"></h3>
						<p  v-html="message"></p>
						<div class="button-group">
							<button type="button" class="btn btn-danger" @click="confirm">Discard Changes</button>
							<button type="button" class="btn btn-outline-muted-gray" @click="cancel">Cancel</button>
						</div>
					</div>
				</template>
			</div>
		`,
		methods: {
			confirm() {
				this.$emit('confirm');
			},
			cancel() {
				this.$emit('cancel');
			}
		}
	};

	Adzuki.VueComponents.AdzukiConfirm = component;
}(jQuery, window.Adzuki || {}));
